









import Vue from 'vue'
import { mapGetters } from 'vuex'

import Banner from '@/components/Banner.vue'
import YearModelSelector from '@/components/YearModelSelector.vue'
import CarCarousel from '@/components/CarCarousel.vue'
import ModelsList from '@/components/ModelsList.vue'

export default Vue.extend({
  name: 'Home',
  data: function() {
    return {
    }
  },
  computed: {
    ...mapGetters({
      trimsList: 'trims/list',
      selectedModelId: 'models/currentModelId'
    }),
  },
  components: {
    Banner,
    YearModelSelector,
    CarCarousel,
    ModelsList
  }
})
